<template>
  <div class="core">
    <div class="layui-fluid">
      <div>
        <div class="layui-form layui-card-header layuiadmin-card-header-auto">
          <div class="layui-inline" style="width: 170px">
            <input
              type="text"
              autocomplete="off"
              class="layui-input"
              placeholder="请输入查询条件"
              v-model="
                tableObj.queryObject[
                  'WORK_ORDER_NUM:2,CLIENT_NAME:2,BRAND_NAME:2,STORE_NAME:2,MANAGER_NAME:2,SERVICE_NAME:2,SERVICE_ORDER_NUM:2,ENGINEER_NAME:2'
                ]
              "
            />
          </div>
          <div class="layui-inline"><label class="layui-search-label">时间段:</label></div>
          <div class="layui-inline" style="width: 195px">
            <layui-daterange
              class="dateRange"
              v-model="tableObj.queryObject.TIME_RANGE"
              @dateChange="handleDateChange($event)"
              ref="daterange"
            ></layui-daterange>
          </div>
          <button class="layui-btn layuiadmin-btn-list" title="查询" @click="search()">查 询</button>
          <button
            class="layui-btn fold-flag advanced"
            title="高级搜索"
            @click="handleChangeAdvance"
            style="padding:0 12px"
          >
            展开高级搜索
          </button>
          <div style="float: right;">
             <button class="layui-btn refresh import" title="导入" v-if="true">
                <span style="display:none" id="importWarpper">
                  <form enctype="multipart/form-data" style="margin-top: 20px;margin-bottom:10px;">
                      <div style="margin-left: 8.33333333%;">
                          <input type="file" id="file" accept=".xls,.xlsx"/>
                          <div style="margin-top:10px;padding-top:5px">
                            <a style="cursor:pointer;color: blue" href="/static/template/现场服务单模板(运维单).xlsx" class="btn btn-default btn-xs">
                              <i class="fa fa-file-excel-o"></i> 下1载模板(运维单)
                            </a>
                            <a style="cursor:pointer;color: blue; padding-left: 30px" href="/static/template/现场服务单模板(工程单).xlsx" class="btn btn-default btn-xs">
                              <i class="fa fa-file-excel-o"></i> 下2载模板(工程单)
                            </a>
                          </div>
                          <font color="red" style="margin-top:10px;display: block;">
                            提示：仅允许导入“xls”或“xlsx”格式文件！
                          </font>
                      </div>
                  </form>
                </span>
                  导入
                  <i class="layui-icon">&#xe625;</i>
                </button>
            <button class="layui-btn refresh" title="刷新列表" @click="reset()">
              <i class="layui-icon">&#xe669;</i>
              刷 新
            </button>
            <button class="layui-btn refresh" title="导出excel" @click="exportExcel()" style="margin-right:10px">
              <i class="layui-icon">&#xe67d;</i>
              导出
            </button>
            <layui-exportexcel ref="export"></layui-exportexcel>
            <button class="layui-btn" title="创建现场服务运维单" @click="addOrder('yw')" v-if="this.security.hasAuth('siteManage_addOrder')">
              <i class="layui-icon">&#xe624;</i>运维单
            </button>
            <button class="layui-btn deep" title="创建现场服务工程单" @click="addOrder('gc')" v-if="this.security.hasAuth('siteManage_addOrder')">
              <i class="layui-icon">&#xe624;</i>工程单
            </button>
          </div>
        </div>
        <advanced-query
          ref="advancedObj"
          :tableObj="tableObj"
          :advanced="searchConfig.advanced"
          v-show="advancedShow"
          @advancedQuery="handleChangeAdvance"
        ></advanced-query>
      </div>
      <div class="layui-tab layui-tab-brief">
        <ul class="layui-tab-title">
          <li :class="tab == 'yw' ? 'layui-this' : ''" @click="handleChangeTab('yw')">现场服务运维单</li>
          <li :class="tab == 'gc' ? 'layui-this' : ''" @click="handleChangeTab('gc')">现场服务工程单</li>
        </ul>
        <div class="layui-tab-content">
          <div class="layui-tab-item" :class="tab == 'yw' ? 'layui-show' : ''">
            <layui-table
              ref="siteTable_yw"
              :renderRow="renderRow"
              :lazy="true"
              table-name="YW_SERVICE_ORDER"
              view-name="YW_SERVICE_ORDER_V1"
              :defaultCondition="{ WORK_ORDER_CATEGORY: 1, 'SERVICE_DELETED:10': '1' }"
              :page-size="20"
              :page-range="6"
              :page-options="[10, 20, 50, 100]"
              :skin="'line'"
              height="full-265"
              :sort="['YW_SERVICE_ORDER_CREATE_TIME:DESC']"
              @table-event-edit="edit($event.data, 'yw')"
              @table-event-detail="detail($event.data, 'yw')"
              @table-event-del="delRow($event, 'yw')"
              @table-event-close="close($event.data, 'yw')"
              @table-event-cxpd="resetOrder($event.data)"
              @table-event-ys="accept($event.data, 'ys')"
              @table-event-selfInspection="selfInspection($event.data, 'yw')"
            >
              <div>
                <div checkbox="true" align="center" fixed="left" width="60"></div>
                <layui-tableconfig :config="tableList_yw"></layui-tableconfig>
                <div rowspan="3" align="center" fixed="right" title="操作" width="150">
                  <script type="text/html" v-pre>
                    <i class="layui-icon t_check_a operate_table" lay-event="detail" title='查看'></i>
                    {{#  if(d._mark.indexOf("siteManage_edit") > -1 && d.SERVICE_STATE.indexOf("4") == -1){ }}
                      <i class="layui-icon t_edit_a operate_table" lay-event="edit" title='编辑'></i>
                    {{#  } }}
                    {{#  if(d.SERVICE_STATE.indexOf("4") > -1 && d.WORK_ORDER_METHOD.indexOf("3") > -1){ }}
                    <i class="layui-icon t_edit_a operate_table" lay-event="selfInspection" title='自检'></i>
                    {{#  } }}
                    {{#  if(d.SERVICE_STATE.indexOf("10") > -1 && d._mark.indexOf("siteManage_close") > -1){ }}
                      <i class="layui-icon t_bd_a operate_table" lay-event="close" title='关单'></i>
                    {{#  } }}
                    {{#  if(d.SERVICE_STATE.indexOf("10") > -1 && !d.AFRESH_DISPATCH_ID && d._mark.indexOf("siteManage_cxpd") > -1){ }}
                      <i class="layui-icon t_pd_a operate_table" lay-event="cxpd" title='派单'></i>
                    {{#  } }}
                    {{#  if(d.SERVICE_STATE.indexOf("5") > -1 && d._mark.indexOf("siteManage_ys") > -1){ }}
                    <i class="layui-icon t_ys_a operate_table" lay-event="ys" title='验收'></i>
                    {{#  } }}
                    {{#  if(d._mark.indexOf("siteManage_del") > -1){ }}
                      <i class="layui-icon t_del_a operate_table" lay-event="del" title='删除'></i>
                    {{#  } }}
                  </script>
                </div>
              </div>
            </layui-table>
          </div>
          <div class="layui-tab-item" :class="tab == 'gc' ? 'layui-show' : ''">
            <layui-table
              ref="siteTable_gc"
              :renderRow="renderRow"
              :lazy="true"
              table-name="YW_SERVICE_ORDER"
              view-name="YW_SERVICE_ORDER_V1"
              :defaultCondition="{ WORK_ORDER_CATEGORY: 2, 'SERVICE_DELETED:10': '1' }"
              :page-size="20"
              :page-range="6"
              :page-options="[10, 20, 50, 100]"
              :skin="'line'"
              height="full-261"
              :sort="['YW_SERVICE_ORDER_CREATE_TIME:DESC']"
              @table-event-edit="edit($event.data, 'gc')"
              @table-event-detail="detail($event.data, 'gc')"
              @table-event-del="delRow($event, 'gc')"
              @table-event-close="close($event.data, 'gc')"
              @table-event-cxpd="resetOrder($event.data)"
              @table-event-ys="accept($event.data, 'ys')"
            >
              <div>
                <div checkbox="true" align="center" fixed="left" width="60"></div>
                <layui-tableconfig :config="tableList_gc"></layui-tableconfig>
                <div rowspan="3" align="center" fixed="right" title="操作" width="150">
                  <script type="text/html" v-pre>
                    <i class="layui-icon t_check_a operate_table" lay-event="detail" title='查看'></i>
                    {{#  if(d._mark.indexOf("siteManage_edit") > -1){ }}
                      <i class="layui-icon t_edit_a operate_table" lay-event="edit" title='编辑'></i>
                    {{#  } }}
                    {{#  if(d.SERVICE_STATE.indexOf("10") > -1 && d._mark.indexOf("siteManage_close") > -1){ }}
                      <i class="layui-icon t_bd_a operate_table" lay-event="close" title='关单'></i>
                    {{#  } }}
                    {{#  if(d.SERVICE_STATE.indexOf("10") > -1 && !d.AFRESH_DISPATCH_ID && d._mark.indexOf("siteManage_cxpd") > -1){ }}
                      <i class="layui-icon t_pd_a operate_table" lay-event="cxpd" title='重新派单'></i>
                    {{#  } }}
                    {{#  if(d.SERVICE_STATE.indexOf("5") > -1 && d._mark.indexOf("siteManage_ys") > -1){ }}
                    <i class="layui-icon t_ys_a operate_table" lay-event="ys" title='验收'></i>
                    {{#  } }}
                    {{#  if(d._mark.indexOf("siteManage_del") > -1){ }}
                      <i class="layui-icon t_del_a operate_table" lay-event="del" title='删除'></i>
                    {{#  } }}
                  </script>
                </div>
              </div>
            </layui-table>
          </div>
        </div>
      </div>
    </div>
    <site-form v-if="operation" :visible.sync="operation" :formData="formData" :orderType="orderType" />
  </div>
</template>
<script>
import '../../../utils/map/css/core.css'
import siteForm from './siteForm'

export default {
  name: 'siteManage',
  components: {
    siteForm
  },
  data() {
    return {
      tab: 'yw',
      tableList_yw: [
        { field: 'SERVICE_STATE_DESC', title: '现场服务单状态', width: 150, sort: true },
        { field: 'WORK_ORDER_TYPE_DESC', title: '现场服务单类型', width: 130 },
        { field: 'WORK_ORDER_NUM', title: '服务请求单编号', width: 150 },
        { field: 'SERVICE_ORDER_NUM', title: '现场服务单编号', width: 150 },
        { field: 'CLIENT_NAME', title: '客户', width: 260 },
        { field: 'BRAND_NAME', title: '品牌', width: 130 },
        { field: 'STORE_NAME', title: '门店', width: 230 },
        { field: 'ENGINEER_ID_DESC', title: '工程师', width: 100 },
        { field: 'SERVICE_NAME', title: '服务商', width: 200 },
        { field: 'YW_SERVICE_ORDER_CREATE_TIME', title: '创建时间', width: 160 }
      ],
      tableList_gc: [
        { field: 'SERVICE_STATE_DESC', title: '现场服务单状态', width: 150, sort: true },
        { field: 'WORK_ORDER_TYPE_DESC', title: '现场服务单类型', width: 130 },
        { field: 'WORK_ORDER_NUM', title: '服务请求单编号', width: 150 },
        { field: 'SERVICE_ORDER_NUM', title: '现场服务单编号', width: 150 },
        { field: 'CLIENT_NAME', title: '客户', width: 260 },
        { field: 'BRAND_NAME', title: '品牌', width: 130 },
        { field: 'STORE_NAME', title: '门店', width: 230 },
        { field: 'ENGINEER_ID_DESC', title: '工程师', width: 100 },
        { field: 'SERVICE_NAME', title: '服务商', width: 200 },
        { field: 'YW_SERVICE_ORDER_CREATE_TIME', title: '创建时间', width: 160 }
      ],
      tableObj: {
        checkedRows: 0,
        queryObject: {}
      },
      searchConfig: {
        basic: [
          {
            TYPE: 'input',
            WIDTH: 260,
            FIELD:
              'WORK_ORDER_NUM:2,CLIENT_NAME:2,BRAND_NAME:2,STORE_NAME:2,MANAGER_NAME:2,SERVICE_NAME:2,SERVICE_ORDER_NUM:2,ENGINEER_NAME:2',
            PLACEHOLDER: '请输入查询条件'
          }
        ],
        advanced: [
          { TYPE: 'input', NAME: '服务请求单编号 :', FIELD: 'WORK_ORDER_NUM:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '现场服务单编号 :', FIELD: 'SERVICE_ORDER_NUM:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '项目经理 :', FIELD: 'MANAGER_NAME:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '服务商 :', FIELD: 'SERVICE_NAME:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '工程师 :', FIELD: 'ENGINEER_NAME:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '客户 :', FIELD: 'CLIENT_NAME:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '品牌 :', FIELD: 'BRAND_NAME:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '门店 :', FIELD: 'STORE_NAME:2', PLACEHOLDER: '请输入查询条件' },
          {
            TYPE: 'layui-multiselect',
            NAME: '现场服务单状态:',
            FIELD: 'SERVICE_STATE:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('SERVICE_STATE')
          },
          {
            TYPE: 'layui-multiselect',
            NAME: '现场服务单类型:',
            FIELD: 'WORK_ORDER_TYPE:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('WORK_ORDER_TYPE')
          },
          {
            TYPE: 'layui-multiselect',
            NAME: '验收结果:',
            FIELD: 'ACCEPTANCE_RESULT:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('ACCEPTANCE_RESULT')
          }
        ]
      },
      moreBtn: [
        { title: '派单', id: '1' },
        { title: '催单', id: '2' },
        { title: '关闭', id: '3' },
        { title: '删除', id: '4' },
        { title: '查看记录', id: '5' }
      ],
      operation: false,
      orderType: '',
      exportTemplate: '现场服务管理表.xlsx',
      advancedShow: false
    }
  },
  mounted() {
    this.tableObj_yw = this.$refs.siteTable_yw
    this.tableObj_gc = this.$refs.siteTable_gc
    this.tableObj = this.tableObj_yw
    if (this.tabParam) {
      if ((this.tabParam.source = 'viewBoard')) {
        this.requestUniqueId = this.tabParam.requestUniqueId
        this.tableObj_yw.requestUniqueId = this.tabParam.requestUniqueId
        this.tableObj_gc.requestUniqueId = this.tabParam.requestUniqueId
        if (this.tabParam.title == '本周总现场服务单') {
          this.api.getServerWeekRange().then(time => {
            var timeSplit = time.split(' - ')
            var start = timeSplit[0].split(' ')[0]
            var end = timeSplit[1].split(' ')[0]
            var selectTime = start + ' - ' + end
            this.$set(this.tableObj.queryObject, 'TIME_RANGE', selectTime)
            this.handleDateChange(selectTime)
            this.tableObj_yw.queryObject = this.tableObj.queryObject
            this.tableObj_gc.queryObject = this.tableObj.queryObject
            this.tableObj_yw.load()
          })
        } else if (this.tabParam.title == '本月总现场服务单') {
          this.api.getServerMonthRange().then(time => {
            var timeSplit = time.split(' - ')
            var start = timeSplit[0].split(' ')[0]
            var end = timeSplit[1].split(' ')[0]
            var selectTime = start + ' - ' + end
            this.$set(this.tableObj.queryObject, 'TIME_RANGE', selectTime)
            this.handleDateChange(selectTime)
            this.tableObj_yw.queryObject = this.tableObj.queryObject
            this.tableObj_gc.queryObject = this.tableObj.queryObject
            this.tableObj_yw.load()
          })
        } else if (this.tabParam.title == '上周总现场服务单') {
          this.api.getServerLastWeekRange().then(time => {
            var timeSplit = time.split(' - ')
            var start = timeSplit[0].split(' ')[0]
            var end = timeSplit[1].split(' ')[0]
            var selectTime = start + ' - ' + end
            this.$set(this.tableObj.queryObject, 'TIME_RANGE', selectTime)
            this.handleDateChange(selectTime)
            this.tableObj_yw.queryObject = this.tableObj.queryObject
            this.tableObj_gc.queryObject = this.tableObj.queryObject
            this.tableObj_yw.load()
          })
        } else if (this.tabParam.title == '近三天工程师忙闲情况') {
          this.api.getServerNearThreeDaysRange().then(time => {
            var timeSplit = time.split(' - ')
            var start = timeSplit[0].split(' ')[0]
            var end = timeSplit[1].split(' ')[0]
            var selectTime = start + ' - ' + end
            this.$set(this.tableObj.queryObject, 'TIME_RANGE', selectTime)
            this.handleDateChange(selectTime)
            this.tableObj_yw.queryObject = this.tableObj.queryObject
            this.tableObj_gc.queryObject = this.tableObj.queryObject
            this.tableObj_yw.load()
          })
        } else {
          this.tableObj_yw.load()
        }
      }
    } else {
      this.tableObj_yw.load()
    }

    // 导入
    var importId = this.uuid()
    var that = this
    var element = (this.el = $(this.$el))
    var importEl = element.find('.import')
    importEl.attr('id', importId)

    this.layui.dropdown.render({
      elem: '#' + importId,
      data: [
        { title: '导入工程单', id: 1 },
        { title: '导入运维单', id: 2 }
      ],
      click: function(obj) {
        if (obj.id == 1) {
          that.importServiceOrderData(obj.id)
        } else if (obj.id == 2) {
          that.importServiceOrderData(obj.id)
        }
      }
    })

    //监听派单跳转
    this.$bus.$on('dispatchForm', () => {
      this.dispatchForm = true
    })

    //监听验收跳转
    this.$bus.$on('acceptForm', () => {
      this.acceptForm = true
    })

    //监听客户服务请求删除
    this.$bus.$on('delWordOrder', () => {
      this.delWordOrder = true
    })
  },
  activated() {
    if (this.dispatchForm) {
      this.dispatchForm = false
      this.tableObj_yw.load()
      this.tableObj_gc.load()
    }
    if (this.acceptForm) {
      this.acceptForm = false
      this.tableObj_yw.load()
      this.tableObj_gc.load()
    }
    if (this.delWordOrder) {
      this.delWordOrder = false
      this.tableObj_yw.load()
      this.tableObj_gc.load()
    }
  },
  methods: {
    // 批量导入
    importServiceOrderData(importType) {
      let that = this

      let url;
      if (importType === 2) {
        url = process.env.API_HOST + '/newData/import/service_order_yw?token=' + that.security.getToken()
      } else {
        url = process.env.API_HOST + '/newData/import/service_order_gc?token=' + that.security.getToken()
      }

      this.layui.layer.open({
        type: 1,
        area: ['400px', '230px'],
        fix: false,
        //不固定
        maxmin: true,
        shade: 0.3,
        title: '上传数据',
        content: $('#importWarpper').html(),
        btn: ['<i class="fa fa-check"></i> 导入', '<i class="fa fa-remove"></i> 取消'],
        // 弹层外区域关闭
        shadeClose: true,
        btn1: function(index, layero) {
          var file = layero.find('#file').val()
          if (file == '' || (!file.endsWith('.xls') && !file.endsWith('.xlsx'))) {
            that.layer.openAlert('请选择后缀为 “xls”或“xlsx”的文件。')
            return false
          }
          var index = layer.load(2, { shade: false })
          var formData = new FormData()
          formData.append('file', layero.find('#file')[0].files[0])
          $.ajax({
            url: url,
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function(result) {
              layer.closeAll()
              if (result.errorMsg) {
                that.layer.openAlert(result.errorMsg)
                return
              }
              result = result.result
              layer.close(index)
              if (result != '') {
                that.$nextTick(() => {
                  that.tableObj.load()
                })
              }
            },
            error: function(err) {
              layer.close(index)
            }
          })
        }
      })
    },

    /**
     * tabs改变事件
     */
    handleChangeTab(type) {
      if (this.tab != type) {
        if (type == 'yw') {
          this.tableObj_yw.queryObject = this.tableObj.queryObject
          this.tableObj_yw.load()
          this.tableObj = this.tableObj_yw
        } else {
          this.tableObj_gc.queryObject = this.tableObj.queryObject
          this.tableObj_gc.load()
          this.tableObj = this.tableObj_gc
        }
      }
      this.tab = type
    },
    handleChangeAdvance() {
      this.advancedShow = !this.advancedShow
      $('.advanced').html(this.advancedShow ? '收起高级搜索' : '展开高级搜索')
    },
    //重新派单
    resetOrder(params) {
      var editRow = params
      //TODO, 需要清空返，只保留服务单编号等信息
      Object.keys(editRow).map(key => {
        if ('F_WORK_ORDER_ID,SERVICE_ORDER_ID,WORK_ORDER_CATEGORY'.indexOf(key) == -1) {
          delete editRow[key]
        }
      })
      editRow.IS_NEW = true
      editRow.SERVICE_STATE = '1' //待接单
      editRow.AFRESH_DISPATCH = 'true' //重新派单
      editRow.SERVICE_ORDER_ID_OLD = editRow.SERVICE_ORDER_ID
      if (params.WORK_ORDER_CATEGORY == '1') {
        this.baseComponent.smartLoadComponent('siteRequestForm', {
          serviceRequest: this,
          tableObj: this.tableObj,
          editRow: editRow,
          type: 'yw',
          title: '创建现场服务运维单'
        })
      } else {
        this.baseComponent.smartLoadComponent('siteRequestForm', {
          serviceRequest: this,
          tableObj: this.tableObj,
          editRow: editRow,
          type: 'gc',
          title: '创建现场服务工程单'
        })
      }
    },
    //验收
    accept(data, orderType) {
      var componentName = 'siteAcceptForm-' + data['SERVICE_ORDER_NUM']
      if (data.WORK_ORDER_CATEGORY == '1') {
        this.baseComponent.smartLoadComponent(
          'siteForm',
          {
            title: '验收-' + data['SERVICE_ORDER_NUM'],
            source: 'workOrder',
            formData: data,
            orderType: orderType,
            tableObj: this.tableObj_yw
          },
          { uniqueName: componentName }
        )
      } else {
        this.baseComponent.smartLoadComponent(
          'siteForm',
          {
            title: '验收-' + data['SERVICE_ORDER_NUM'],
            source: 'workOrder',
            formData: data,
            orderType: orderType,
            tableObj: this.tableObj_gc
          },
          { uniqueName: componentName }
        )
      }
    },
    // 关单
    close(rows, status) {
      let reqId = 'YW_SERVICE_ORDER'
      let tableObj = status === 'yw' ? this.tableObj_yw : this.tableObj_gc
      this.layer.openConfirm('确定要关闭这条工单吗?', () => {
        rows.SERVICE_STATE = '7'
        rows.IS_NEW = false
        this.api.save('YW_SERVICE_ORDER', rows, reqId).then(response => {
          if (response.errorMsg) {
            this.layer.openAlert(response.errorMsg, false, undefined, { targetEl: this.outside && $(this.outside) })
          } else {
            tableObj.load()
            this.layer.openSuccess('关闭成功!')
          }
        })
      })
    },
    //逻辑删除
    delRow($event, orderType) {
      if (orderType == 'yw') {
        this.$refs.siteTable_yw.delRows($event.data, { isLogic: true, reqId: 'delServiceOrder' })
      } else {
        this.$refs.siteTable_gc.delRows($event.data, { isLogic: true, reqId: 'delServiceOrder' })
      }
    },
    /**
     * 新增工单
     */
    addOrder(orderType) {
      if (orderType == 'yw') {
        this.baseComponent.smartLoadComponent('siteRequestForm', {
          siteRequest: this,
          tableObj: this.tableObj_yw,
          type: 'yw',
          title: '创建现场服务运维单'
        })
      } else {
        this.baseComponent.smartLoadComponent('siteRequestForm', {
          siteRequest: this,
          tableObj: this.tableObj_gc,
          type: 'gc',
          title: '创建现场服务工程单'
        })
      }
    },
    selfInspection(data, orderType) {
      if (data.WORK_ORDER_METHOD === '3') {
        this.baseComponent.smartLoadComponent('thirdPartyServicesSelfInspectionForm', {
          siteRequest: this,
          tableObj: this.tableObj_yw,
          editRow: data,
          type: 'yw',
          title: '编辑第三方服务待自检表单',
          requestUniqueId: 'editThirdPartyServices',
          input_disabled: true
        })
      }
    },
    edit(data, orderType) {
      if (orderType == 'yw') {
        if (data.WORK_ORDER_METHOD === '3') {
          this.baseComponent.smartLoadComponent('thirdPartyServicesForm', {
            siteRequest: this,
            tableObj: this.tableObj_yw,
            editRow: data,
            type: 'yw',
            title: '编辑第三方服务单',
            requestUniqueId: 'editThirdPartyServices',
            input_disabled: true
          })
        } else {
          this.baseComponent.smartLoadComponent('siteRequestForm', {
            siteRequest: this,
            tableObj: this.tableObj_yw,
            editRow: data,
            type: 'yw',
            title: '编辑现场服务运维单',
            requestUniqueId: 'editServiceOrder',
            input_disabled: true
          })
        }
      } else {
        this.baseComponent.smartLoadComponent('siteRequestForm', {
          siteRequest: this,
          tableObj: this.tableObj_gc,
          editRow: data,
          type: 'gc',
          title: '编辑现场服务工程单',
          requestUniqueId: 'editServiceOrder',
          input_disabled: true
        })
      }
    },
    //查看
    detail(data, orderType) {
      var componentName = 'siteForm-' + data['SERVICE_ORDER_NUM']
      this.baseComponent.smartLoadComponent(
        'siteForm',
        { title: '详情-' + data['SERVICE_ORDER_NUM'], source: 'workOrder', formData: data },
        { uniqueName: componentName }
      )
    },
    search() {
      if (this.tab == 'yw') {
        this.tableObj_yw.queryObject = this.tableObj.queryObject
        this.tableObj_yw.load()
      } else {
        this.tableObj_gc.queryObject = this.tableObj.queryObject
        this.tableObj_gc.load()
      }
    },
    reset() {
      this.advancedShow = false
      this.$refs.advancedObj.clear()
      this.tableObj.queryObject = {}
      this.tableObj_yw.queryObject = {}
      this.tableObj_gc.queryObject = {}
      if (this.tab == 'yw') {
        this.tableObj_yw.load()
      } else {
        this.tableObj_gc.load()
      }
    },
    //导出(运维单和工程单一块导出)
    exportExcel() {
      let tableObj = {}
      tableObj.tableName = 'YW_SERVICE_ORDER_V1'
      tableObj.queryObject = this.tableObj.queryObject
      var exportObj = this.$refs.export
      exportObj.requestUniqueId = this.requestUniqueId
      exportObj.setTemplateName(this.exportTemplate)
      exportObj.export(tableObj)
    },
    more(params) {
      this.layui.dropdown.render({
        elem: params.el,
        data: this.moreBtn,
        click: function(data, othis) {
          var elem = $(this.elem),
            listId = elem.data('id') //表格列表的预埋数据
          layer.msg('得到表格列表的 id：' + listId + '，下拉菜单 id：' + data.id)
        }
      })
      $(params.el).click()
    },
    renderRow(data) {
      //1.待接单  2.待预约 3.待签到  4.待自检  5.待内部验收  6.待签退  7.已关闭  8.已返单 9. 待评价 10.验收不通过)
      if (data.SERVICE_STATE == 1) {
        data.SERVICE_STATE_DESC = '待接单'
      } else if (data.SERVICE_STATE == 2) {
        data.SERVICE_STATE_DESC = '待预约'
      } else if (data.SERVICE_STATE == 3) {
        data.SERVICE_STATE_DESC = '待签到'
      } else if (data.SERVICE_STATE == 4) {
        data.SERVICE_STATE_DESC = '待自检'
      } else if (data.SERVICE_STATE == 5) {
        data.SERVICE_STATE_DESC = '待内部验收'
      } else if (data.SERVICE_STATE == 6) {
        data.SERVICE_STATE_DESC = '待签退'
      } else if (data.SERVICE_STATE == 7) {
        data.SERVICE_STATE_DESC = '已完成'
      } else if (data.SERVICE_STATE == 8) {
        data.SERVICE_STATE_DESC = '已返单'
      } else if (data.SERVICE_STATE == 9) {
        data.SERVICE_STATE_DESC = '待评价'
      } else if (data.SERVICE_STATE == 10) {
        data.SERVICE_STATE_DESC = '验收不通过'
      }
    },
    handleDateChange(daterange) {
      this.tableObj.queryObject.TIME_RANGE = daterange
      var range = daterange.split(' - ')
      var startTime = range[0]
      var endTime = range[1]
      this.tableObj.queryObject['YW_SERVICE_ORDER_CREATE_TIME:5'] = startTime
      this.tableObj.queryObject['YW_SERVICE_ORDER_CREATE_TIME:6'] = endTime + ' 23:59:59'
    }
  }
}
</script>
<style scoped>
.layui-inline >>> .layui-icon-date {
  top: -2px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder/siteManage/index.vue